import React from 'react';

export const LongLineIcon = ({ className }) => {
	return (
		<svg width="208" height="2" viewBox="0 0 208 2" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect width="2" height="208" rx="0.999999" transform="matrix(1.19249e-08 -1 -1 -1.19249e-08 208 2)" fill="#525252" />
		</svg>
	);
};
